import React, { useEffect, useRef } from 'react'

// eslint-disable-next-line import/no-unresolved
import 'altcha/i18n'

const Altcha = ({ setAltchaPayload, locale, challengeUrl, error }) => {
  const widgetRef = useRef(null)

  useEffect(() => {
    const handleStateChange = (ev) => {
      if (ev?.detail?.state && setAltchaPayload) {
        setAltchaPayload(
          ev.detail.state === 'verified' ? ev.detail.payload : null
        )
      }
    }

    const { current } = widgetRef

    if (current) {
      current.addEventListener('statechange', handleStateChange)
      return () => current.removeEventListener('statechange', handleStateChange)
    }
  }, [setAltchaPayload])

  locale = locale ? locale.split('-')[0].toLowerCase() : 'en'

  return (
    <altcha-widget
      ref={widgetRef}
      challengeurl={challengeUrl}
      language={locale}
      style={
        error
          ? {
              '--altcha-color-border': '#d22a0c',
              '--altcha-color-base': '#f7e7e4'
            }
          : {}
      }
    />
  )
}

export default Altcha
